import React from 'react';
import { observer } from 'mobx-react';
import { samplingDistributions } from 'mobx-store';

import SamplingDistributionsComponent from './Component';

const SamplingDistributionsContainer = observer(
  class SamplingDistributionsContainer extends React.Component {

    /*
     * componentWillUnmount () {
     *   this.props.resetSamples()
     * }
     */

    render () {
      return (
        <SamplingDistributionsComponent
          parameterType={samplingDistributions.parameter.type}
          showRightAndBottomPanes={samplingDistributions.doSamplesExist}
        />
      );
    }
  }
);

export default SamplingDistributionsContainer;
